/**
 * NavigationManager Component
 * Handles navigation between different HUD modes and screens
 */

export function useNavigation() {
  return {
    modes: {
      MAIN: 'main',
      STARCADE: 'starcade',
      PORTFOLIO: 'portfolio',
      ARTEMIS: 'artemis'
    },
    sections: {
      MAIN:      { text: 'EXPLORE THE *FUTURE OF SPACE*' },
      STARCADE:  { text: 'Star*cade*', size: '4.0em' },
      PORTFOLIO: { text: '|We make space| *interactive*' },
      ARTEMIS:   { text: '|RETURN TO| |THE MOON|' }
    },
    locations: {
      spacestation:    { text: "SEE THE HABITATS *BEYOND EARTH*" },
      saxavord:        { text: "DISCOVER THE FUTURE OF *UK LAUNCH*" },
      woomera:         { text: "INTERACT WITH *UK SPACE HISTORY*" },
      etlaq:           { text: "*MODULAR* & *EXPANDABLE* ENVIRONMENTS" },
      lunarops:        { text: "EXPERIENCE THE *LUNAR FRONTIER*" },
      satellite:       { text: "NAVIGATE *SATELLITE* SYSTEMS & OPERATIONS" }
    }
  }
}
